import Box, { BoxProps } from '@mui/material/Box';
import { PropsWithChildren } from 'react';

export type FlexBoxProps = BoxProps['sx'] & {
  onClick?: BoxProps['onClick'];
};

const FlexBox: React.FC<PropsWithChildren<FlexBoxProps>> = ({
  children,
  onClick,
  ...props
}) => (
  <Box sx={{ display: 'flex', ...props }} onClick={onClick}>
    {children}
  </Box>
);

export default FlexBox;
